import { paths } from "../api-sdk/openapi-spec";
import { BEAM_COOKIE_NAMES } from "../api-sdk/constants";
export type TCartApi =
  paths["/chain/findEligibleNonprofitsForCart"]["post"]["requestBody"]["content"]["application/json"]["cart"];

// Same as type from API but with non-optional fields, so we can use where Shopify guarantees values
export type TCart = TCartApi & {
  content: {
    items: Record<string, any>[];
    discounts?: Record<string, any>[] | undefined | null;
  };
};

export type TCartItems = TCart["content"]["items"];

export type TCartDiscounts = TCart["content"]["discounts"];

export type TBeamCartLocalStorage = {
  cartId: string;
  beamCartId?: string;
  subtotal: number;
  itemCount: number;
  currencyCode: string;
} & TCart;

export const BEAM_CART_COOKIE_NAME = BEAM_COOKIE_NAMES.CART;

export type Discount = {
  code: string;
  applicable: boolean;
};
